export const products = [
  {
    id: 1,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 2,
    title: "2021 Nissan Navara in very good condition",
    price: 4850,
    type: "Auction",
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Midrand",
    totalBids: 20,
    imageUrls: ["/assets/images/products/product2.png"],
    productType: "laptop",
  },
  {
    id: 3,
    title: "Epson L6190 A4 Colour Printer in new condition",
    location: "Kempton Park",
    price: 2179950,
    type: "Buy Now",
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product3.png"],
    productType: "electronics",
  },
  {
    id: 4,
    title: "Apartment To Let in Centurion",
    location: "Johanesberg",
    price: 7500,
    type: "Classified Ad",
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product4.png"],
    details: { bedroom: 4, bathroom: 2 },
    productType: "apartment",
  },
  {
    id: 5,
    title: "Bullmastif Puppies for sale",
    location: "Pretoria",
    type: "Classified Ad",
    price: 850,
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product5.png"],
    productType: "pet",
  },
  {
    id: 6,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 7,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 8,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 9,
    title: "Apartment To Let in Centurion",
    location: "Johanesberg",
    price: 7500,
    type: "Classified Ad",
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product4.png"],
    details: { bedroom: 4, bathroom: 2 },
    productType: "apartment",
  },
  {
    id: 10,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 11,
    title: "2021 Nissan Navara in very good condition",
    price: 4850,
    type: "Auction",
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Midrand",
    totalBids: 20,
    imageUrls: ["/assets/images/products/product2.png"],
    productType: "laptop",
  },
  {
    id: 12,
    title: "Epson L6190 A4 Colour Printer in new condition",
    location: "Kempton Park",
    price: 2179950,
    type: "Buy Now",
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product3.png"],
    productType: "electronics",
  },
  {
    id: 13,
    title: "Apartment To Let in Centurion",
    location: "Johanesberg",
    price: 7500,
    type: "Classified Ad",
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product4.png"],
    details: { bedroom: 4, bathroom: 2 },
    productType: "apartment",
  },
  {
    id: 14,
    title: "Bullmastif Puppies for sale",
    location: "Pretoria",
    type: "Classified Ad",
    price: 850,
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product5.png"],
    productType: "pet",
  },
  {
    id: 15,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 16,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 17,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 18,
    title: "Apartment To Let in Centurion",
    location: "Johanesberg",
    price: 7500,
    type: "Classified Ad",
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product4.png"],
    details: { bedroom: 4, bathroom: 2 },
    productType: "apartment",
  },
  {
    id: 19,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 20,
    title: "2021 Nissan Navara in very good condition",
    price: 4850,
    type: "Auction",
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Midrand",
    totalBids: 20,
    imageUrls: ["/assets/images/products/product2.png"],
    productType: "laptop",
  },
  {
    id: 21,
    title: "Epson L6190 A4 Colour Printer in new condition",
    location: "Kempton Park",
    price: 2179950,
    type: "Buy Now",
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product3.png"],
    productType: "electronics",
  },
  {
    id: 22,
    title: "Apartment To Let in Centurion",
    location: "Johanesberg",
    price: 7500,
    type: "Classified Ad",
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product4.png"],
    details: { bedroom: 4, bathroom: 2 },
    productType: "apartment",
  },
  {
    id: 23,
    title: "Bullmastif Puppies for sale",
    location: "Pretoria",
    type: "Classified Ad",
    price: 850,
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product5.png"],
    productType: "pet",
  },
  {
    id: 24,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 25,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 26,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 27,
    title: "Apartment To Let in Centurion",
    location: "Johanesberg",
    price: 7500,
    type: "Classified Ad",
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product4.png"],
    details: { bedroom: 4, bathroom: 2 },
    productType: "apartment",
  },
  {
    id: 28,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 29,
    title: "2021 Nissan Navara in very good condition",
    price: 4850,
    type: "Auction",
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Midrand",
    totalBids: 20,
    imageUrls: ["/assets/images/products/product2.png"],
    productType: "laptop",
  },
  {
    id: 30,
    title: "Epson L6190 A4 Colour Printer in new condition",
    location: "Kempton Park",
    price: 2179950,
    type: "Buy Now",
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product3.png"],
    productType: "electronics",
  },
  {
    id: 31,
    title: "Apartment To Let in Centurion",
    location: "Johanesberg",
    price: 7500,
    type: "Classified Ad",
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product4.png"],
    details: { bedroom: 4, bathroom: 2 },
    productType: "apartment",
  },
  {
    id: 32,
    title: "Bullmastif Puppies for sale",
    location: "Pretoria",
    type: "Classified Ad",
    price: 850,
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product5.png"],
    productType: "pet",
  },
  {
    id: 33,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 34,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 35,
    title: "2021 Nissan Navara in very good condition",
    price: 2179950,
    endTime: "2023-01-31T23:59:59.999Z",
    location: "Johanesberg",
    type: "Classified Ad",
    productType: "vehicle",
    details: {
      model: 2021,
      totalTravelled: 137888,
    },
    imageUrls: ["/assets/images/products/product1.png"],
  },
  {
    id: 36,
    title: "Apartment To Let in Centurion",
    location: "Johanesberg",
    price: 7500,
    type: "Classified Ad",
    endTime: "2023-01-31T23:59:59.999Z",
    imageUrls: ["/assets/images/products/product4.png"],
    details: { bedroom: 4, bathroom: 2 },
    productType: "apartment",
  },
];
